<template>
  <BaseView>
    <ContactUs />
  </BaseView>
</template>

<script lang="ts" setup>
import BaseView from '@/views/BaseView.vue'
import ContactUs from '@/app/views/About/ContactUs.vue'
</script>
